/**
 * One Line Calendar - Widget (calendar render, UI updates)
 * No Liquid. Depends on one-line-calendar-core.js
 */
(function() {
  'use strict';

  if (!window.HanaleiBooking || !window.HanaleiBooking.utils) return;

  var utils = window.HanaleiBooking.utils;
  var api = window.HanaleiBooking.api;

  function isDateUnavailable(date, config) {
    return api.isConfigured(config.listingId, config.apiBase) && api.isDateUnavailable(date, config.listingId);
  }

  function renderDayCell(date, day, isAdjacent, state, config) {
    var classes = ['calendar-popup__day'];
    var clickable = true;
    if (isAdjacent) classes.push('calendar-popup__day--adjacent');
    if (utils.isDatePast(date)) {
      classes.push('calendar-popup__day--past');
      clickable = false;
    } else if (isDateUnavailable(date, config)) {
      classes.push('calendar-popup__day--unavailable');
      clickable = false;
    }
    if (utils.isSameDate(date, state.checkinDate)) classes.push('calendar-popup__day--start');
    if (utils.isSameDate(date, state.checkoutDate)) classes.push('calendar-popup__day--end');
    if (utils.isDateInRange(date, state.checkinDate, state.checkoutDate)) classes.push('calendar-popup__day--in-range');
    return '<div class="' + classes.join(' ') + '"' + (clickable ? ' data-date="' + date.toISOString() + '"' : '') + '><span>' + day + '</span></div>';
  }

  function renderSkeleton() {
    var html = '';
    for (var i = 0; i < 42; i++) {
      html += '<div class="calendar-popup__day-skeleton"></div>';
    }
    return html;
  }

  function renderCalendar(state, config, elements) {
    if (!elements.calendarMonth || !elements.calendarGrid) return;
    elements.calendarMonth.textContent = utils.getMonthName(state.currentMonth) + ' ' + state.currentYear;

    var isLoading = api.isConfigured(config.listingId, config.apiBase) && api.isLoading(config.listingId);

    if (isLoading) {
      elements.calendarGrid.innerHTML = renderSkeleton();
      elements.calendarGrid.classList.add('calendar-popup__grid--loading');
      return;
    }

    elements.calendarGrid.classList.remove('calendar-popup__grid--loading');

    var daysInMonth = utils.getDaysInMonth(state.currentYear, state.currentMonth);
    var firstDay = utils.getFirstDayOfMonth(state.currentYear, state.currentMonth);
    var prevM = state.currentMonth === 0 ? 11 : state.currentMonth - 1;
    var prevY = state.currentMonth === 0 ? state.currentYear - 1 : state.currentYear;
    var daysPrev = utils.getDaysInMonth(prevY, prevM);
    var nextM = state.currentMonth === 11 ? 0 : state.currentMonth + 1;
    var nextY = state.currentMonth === 11 ? state.currentYear + 1 : state.currentYear;

    var html = '', i, day, d;
    for (i = 0; i < firstDay; i++) {
      day = daysPrev - firstDay + 1 + i;
      html += renderDayCell(new Date(prevY, prevM, day), day, true, state, config);
    }
    for (day = 1; day <= daysInMonth; day++) {
      html += renderDayCell(new Date(state.currentYear, state.currentMonth, day), day, false, state, config);
    }
    var remain = (firstDay + daysInMonth <= 35 ? 35 : 42) - firstDay - daysInMonth;
    for (i = 0; i < remain; i++) {
      html += renderDayCell(new Date(nextY, nextM, i + 1), i + 1, true, state, config);
    }

    elements.calendarGrid.innerHTML = html;
  }

  function setPriceElements(el, fee, clean, total) {
    if (el.bookingFee) el.bookingFee.textContent = fee;
    if (el.cleaningFeeEl) el.cleaningFeeEl.textContent = clean;
    if (el.total) el.total.textContent = total;
    if (el.bookingFeeMobile) el.bookingFeeMobile.textContent = fee;
    if (el.cleaningFeeElMobile) el.cleaningFeeElMobile.textContent = clean;
    if (el.totalMobile) el.totalMobile.textContent = total;
    if (el.popupBookingFee) el.popupBookingFee.textContent = fee;
    if (el.popupCleaningFee) el.popupCleaningFee.textContent = clean;
    if (el.popupTotal) el.popupTotal.textContent = total;
  }

  function toggleNoteTable(el, showTable) {
    if (el.bookingNote) el.bookingNote.classList.toggle('one-line-calendar__note--hidden', showTable);
    if (el.priceTable) el.priceTable.classList.toggle('one-line-calendar__price-table--visible', showTable);
    if (el.bookingNoteMobile) el.bookingNoteMobile.classList.toggle('one-line-calendar__note--hidden', showTable);
    if (el.priceTableMobile) el.priceTableMobile.classList.toggle('one-line-calendar__price-table--visible', showTable);
  }

  function updatePriceUI(state, config, elements, str) {
    str = str || {};
    var nights = utils.getNightsBetween(state.checkinDate, state.checkoutDate);
    var minErr = nights > 0 && nights < config.minNights;
    var note = str.noteText || 'Use the calendar to select your arrival and departure dates.';
    var btnText = str.bookButtonText || 'Book';

    if (nights > 0 && !minErr) {
      var fee = 0;
      var cleaningFee = api.isConfigured(config.listingId, config.apiBase) ? api.getCleaningFee(config.listingId) : 0;
      if (api.isConfigured(config.listingId, config.apiBase) && Object.keys(api.cache || {}).length > 0) {
        var d = new Date(state.checkinDate.getTime());
        for (var i = 0; i < nights; i++) {
          fee += api.getDayPrice(d, config.pricePerNight, config.listingId);
          d.setDate(d.getDate() + 1);
        }
      } else {
        fee = config.pricePerNight * nights;
      }
      var total = fee + cleaningFee;

      toggleNoteTable(elements, true);
      if (elements.bookingNoteText) elements.bookingNoteText.textContent = note;
      if (elements.bookingNoteTextMobile) elements.bookingNoteTextMobile.textContent = note;
      if (elements.bookingNote) elements.bookingNote.classList.remove('one-line-calendar__note--error');
      if (elements.bookingNoteMobile) elements.bookingNoteMobile.classList.remove('one-line-calendar__note--error');

      setPriceElements(elements, utils.formatMoney(fee), utils.formatMoney(cleaningFee), utils.formatMoney(total));

      if (elements.popupCheckinDate && state.checkinDate) elements.popupCheckinDate.textContent = utils.formatDate(state.checkinDate);
      if (elements.popupCheckoutDate && state.checkoutDate) elements.popupCheckoutDate.textContent = utils.formatDate(state.checkoutDate);
      if (elements.popupNightsCount && nights > 0) {
        elements.popupNightsCount.textContent = nights;
        var nl = elements.popupNights && elements.popupNights.querySelector('.booking-popup__nights-label-small');
        if (nl) nl.textContent = nights === 1 ? 'night' : 'nights';
        if (elements.popupNights) elements.popupNights.style.display = 'flex';
      } else if (elements.popupNights) elements.popupNights.style.display = 'none';

      if (elements.priceLabel) elements.priceLabel.style.display = 'none';
      if (elements.priceDisplay) elements.priceDisplay.textContent = utils.formatMoney(fee);
      if (elements.nightsLabel) elements.nightsLabel.textContent = ' for ' + nights + ' night' + (nights > 1 ? 's' : '');
      if (elements.bookBtn) {
        elements.bookBtn.disabled = false;
        elements.bookBtn.textContent = btnText + ' for ' + nights + ' night' + (nights > 1 ? 's' : '');
      }
    } else if (minErr) {
      var err = 'Stay must be at least ' + config.minNights + ' night' + (config.minNights > 1 ? 's' : '') + '.';
      if (elements.bookingNoteText) elements.bookingNoteText.textContent = err;
      if (elements.bookingNoteTextMobile) elements.bookingNoteTextMobile.textContent = err;
      if (elements.bookingNote) elements.bookingNote.classList.add('one-line-calendar__note--error');
      if (elements.bookingNoteMobile) elements.bookingNoteMobile.classList.add('one-line-calendar__note--error');
      toggleNoteTable(elements, false);
      setPriceElements(elements, '$0.00', '$0.00', '$0.00');
      if (elements.priceLabel) elements.priceLabel.style.display = '';
      if (elements.priceDisplay) elements.priceDisplay.textContent = utils.formatMoney(config.pricePerNight);
      if (elements.nightsLabel) elements.nightsLabel.textContent = '/night';
      if (elements.bookBtn) {
        elements.bookBtn.disabled = true;
        elements.bookBtn.textContent = btnText;
      }
    } else {
      toggleNoteTable(elements, false);
      setPriceElements(elements, '$0.00', '$0.00', '$0.00');
      if (elements.bookingNoteText) elements.bookingNoteText.textContent = note;
      if (elements.bookingNoteTextMobile) elements.bookingNoteTextMobile.textContent = note;
      if (elements.bookingNote) elements.bookingNote.classList.remove('one-line-calendar__note--error');
      if (elements.bookingNoteMobile) elements.bookingNoteMobile.classList.remove('one-line-calendar__note--error');
      if (elements.priceLabel) elements.priceLabel.style.display = '';
      if (elements.priceDisplay) elements.priceDisplay.textContent = utils.formatMoney(config.pricePerNight);
      if (elements.nightsLabel) elements.nightsLabel.textContent = '/night';
      if (elements.bookBtn) {
        elements.bookBtn.disabled = false;
        elements.bookBtn.textContent = btnText;
      }
    }

    var section = (elements.total || elements.totalMobile || elements.bookingFee) && (elements.total || elements.totalMobile || elements.bookingFee).closest('.one-line-calendar');
    if (section) {
      if (nights > 0 && !minErr) {
        section.dataset.nights = String(nights);
      } else {
        delete section.dataset.nights;
      }
      section.dispatchEvent(new CustomEvent('hanalei:booking-update', { bubbles: true }));
    }
  }

  function updateGuestsUI(state, config, elements) {
    if (!elements.guestsCount) return;
    elements.guestsCount.textContent = state.guests;
    if (elements.guestsText) elements.guestsText.textContent = state.guests === 1 ? '1 guest' : state.guests + ' guests';
    if (elements.guestsDecrease) elements.guestsDecrease.disabled = state.guests <= 1;
    if (elements.guestsIncrease) elements.guestsIncrease.disabled = state.guests >= config.maxGuests;
  }

  function updatePopupGuestsUI(state, config, elements) {
    if (elements.adultsCount) elements.adultsCount.textContent = state.adults;
    if (elements.childrenCount) elements.childrenCount.textContent = state.children;
    var t = state.adults + state.children;
    if (elements.adultsDecrease) elements.adultsDecrease.disabled = state.adults <= 1;
    if (elements.adultsIncrease) elements.adultsIncrease.disabled = t >= config.maxGuests;
    if (elements.childrenDecrease) elements.childrenDecrease.disabled = state.children <= 0;
    if (elements.childrenIncrease) elements.childrenIncrease.disabled = t >= config.maxGuests;
  }

  function updateDateFieldsUI(state, elements, str) {
    var ph = (str && str.datePlaceholder) || 'Select date';
    if (elements.checkinValue) {
      if (state.checkinDate) {
        elements.checkinValue.textContent = utils.formatDate(state.checkinDate);
        elements.checkinValue.classList.remove('one-line-calendar__date-value--placeholder');
      } else {
        elements.checkinValue.textContent = ph;
        elements.checkinValue.classList.add('one-line-calendar__date-value--placeholder');
      }
    }
    if (elements.checkoutValue) {
      if (state.checkoutDate) {
        elements.checkoutValue.textContent = utils.formatDate(state.checkoutDate);
        elements.checkoutValue.classList.remove('one-line-calendar__date-value--placeholder');
      } else {
        elements.checkoutValue.textContent = ph;
        elements.checkoutValue.classList.add('one-line-calendar__date-value--placeholder');
      }
    }
    if (elements.checkinField) {
      elements.checkinField.classList.toggle('one-line-calendar__date-field--active', state.calendarOpen && state.selectingField === 'checkin');
    }
    if (elements.checkoutField) {
      elements.checkoutField.classList.toggle('one-line-calendar__date-field--active', state.calendarOpen && state.selectingField === 'checkout');
    }
    if (elements.calendarClear) {
      var has = state.checkinDate || state.checkoutDate;
      elements.calendarClear.classList.toggle('calendar-popup__clear-link--hidden', !has);
      elements.calendarClear.setAttribute('aria-hidden', !has);
    }
  }

  function updatePopupSubmitButton(state, config, elements) {
    if (!elements.bookingPopupSubmit) return;
    var t = state.adults + state.children;
    var nights = utils.getNightsBetween(state.checkinDate, state.checkoutDate);
    var minErr = nights > 0 && nights < config.minNights;
    elements.bookingPopupSubmit.disabled = t > config.maxGuests || t < 1 || !state.checkinDate || !state.checkoutDate || minErr;
  }

  window.HanaleiBooking.widget = {
    renderCalendar: renderCalendar,
    updatePriceUI: updatePriceUI,
    updateGuestsUI: updateGuestsUI,
    updatePopupGuestsUI: updatePopupGuestsUI,
    updateDateFieldsUI: updateDateFieldsUI,
    updatePopupSubmitButton: updatePopupSubmitButton,
    toggleNoteTable: toggleNoteTable
  };
})();
